/**
 * Tekstet e faqes prezantuese — shqip, anglisht, gjermanisht.
 *
 * Çmimet dhe regjistrimi marrin tekstet nga `auth/landingContent.js` (aty ishin
 * tashmë në tri gjuhë); këtu rri vetëm ajo që është e kësaj faqeje: kopja, dialogu
 * i demonstrimit dhe shkrimet brenda skenës 3D dhe pamjes statike.
 *
 * Çdo veçori është verifikuar në kod (shih `docs/notes/faqja_prezantuese_*.md`).
 * Kur ndryshon një pikë, ndryshoje në të tria gjuhët.
 */

const sq = {
  title: 'Nexuma — Stafi, orari dhe pagat në një vend',
  skip: 'Kalo te përmbajtja',
  logoLabel: 'Nexuma — fillimi i faqes',
  navLabel: 'Kryesore',
  navLabelMobile: 'Kryesore (telefon)',
  legalLabel: 'Ligjore',
  langLabel: 'Gjuha',
  nav: { 'si-funksionon': 'Si funksionon', prezenca: 'Prezenca', pushimet: 'Pushimet', pagat: 'Pagat', cmimet: 'Çmimet' },
  login: 'Hyr',
  demo: 'Kërko demonstrim',
  start: 'Fillo falas',
  menuOpen: 'Hap menunë',
  menuClose: 'Mbyll menunë',
  hero: {
    h1a: 'Stafi, orari dhe pagat.',
    h1b: 'Në një vend.',
    // Sa zvogëlohet titulli që rreshti i parë të nxë si në shqip (të matura në 1440px).
    h1Fit: 1,
    lead: 'Menaxho prezencën, pushimet dhe dokumentet e stafit nga një platformë e vetme.',
    how: 'Shiko si funksionon',
    note: 'Animacioni është demonstrim me të dhëna shembull.',
  },
  day: {
    title: 'Një ditë pune, nga skanimi te fletëpagesa.',
    clockLabel: 'Ora e momentit',
    // Pamjet e app-it te çdo moment (AppScreens.js) — etiketat si në aplikacion.
    screens: {
      sample: 'Të dhëna shembull',
      labels: {
        prezenca: 'Pamje e aplikacionit: kioska e Nexuma-s te hyrja tregon QR-në që ndërrohet çdo 10 sekonda, dhe telefoni i Dritës konfirmon se prezenca u regjistrua. Të dhëna shembull.',
        pushimet: 'Pamje e aplikacionit: kërkesa e Elirës për pushim vjetor, 3 ditë, në pritje të aprovimit, me butonat Refuzo dhe Aprovo. Të dhëna shembull.',
        dokumentet: 'Pamje e aplikacionit: lista e kontratave me statusin dhe dokumentin e nënshkruar për secilin punëtor. Të dhëna shembull.',
        pagat: 'Pamje e aplikacionit: fletëpagesa e tetorit për Dritën, nga paga bruto te paga neto, e dërguar me email. Të dhëna shembull.',
      },
      roles: ['Magazina', 'Shitje', 'Recepsioni', 'Financa'],
      colStatus: 'Statusi',
      kioskTitle: 'Regjistro Prezencën',
      kioskHint: 'Hap app-in HR → «Skano QR» → skanoje këtë kod',
      kioskName: 'Hyrja kryesore',
      kioskDate: 'E enjte, 29 tetor',
      recorded: 'U regjistrua',
      recordedBody: 'Prezenca u ruajt me sukses.',
      startWork: 'Fillimi punës',
      requests: 'Kërkesat dhe Aprovimet',
      annualLeave: 'Pushim vjetor',
      forApproval: 'Për aprovim',
      employee: 'Punonjësi',
      period: 'Periudha',
      days: 'Ditë',
      daysLeft: (n) => `${n} ditë të mbetura`,
      reject: 'Refuzo',
      approve: 'Aprovo',
      contracts: 'Kontratat',
      contractType: 'Lloji',
      contractTypes: ['Kontratë pa afat', 'Kontratë me afat të caktuar', 'Kontratë provuese'],
      active: 'Aktive',
      expires: (n) => `Skadon · ${n}d`,
      signed: 'Dok. i nënshkruar',
      uploaded: 'Ngarkuar',
      payroll: 'Pagat',
      payslipTitle: 'Fletëpagesë',
      payslipPeriod: '1 – 31 tetor 2026',
      grossBase: 'Paga bazë bruto',
      pension: 'Sig. pensionale (punëtori)',
      tax: 'Tatimi mbi të ardhura',
      net: 'Paga neto',
      mailed: 'Fletëpagesa — Tetor 2026.pdf',
      sent: 'Dërguar',
    },
    stages: [
      {
        id: 'prezenca',
        time: '07:58',
        caption: 'Drita skanon kioskën te hyrja.',
        title: 'Regjistro prezencën',
        lead: 'Punëtori skanon me telefon QR-në e kioskës te hyrja dhe hyrja regjistrohet me orën e saktë. Kioska është thjesht një faqe e Nexuma-s në një tablet ose kompjuter; pa të, hyrja shënohet direkt nga telefoni ose web-i.',
        points: [
          'Tre kanale regjistrimi — kioska me QR, ora në web dhe aplikacioni mobil — të zgjedhura për kompaninë ose për secilin punëtor.',
          'QR-ja e kioskës ndërrohet çdo 10 sekonda, ndaj një fotografi e saj nuk vlen më vonë.',
          'Pamja live e prezencës për menaxherin: prezent, mungon, me leje.',
          'Korrigjimet e prezencës kërkohen, aprovohen dhe pasqyrohen te paga.',
        ],
      },
      {
        id: 'pushimet',
        time: '10:30',
        caption: 'Elira kërkon tri ditë pushim.',
        title: 'Menaxho pushimet',
        lead: 'Kërkesa shkon te aprovuesi, dhe bilanci i ditëve ndiqet sipas llojit të pushimit.',
        points: [
          'Katalog i llojeve të pushimit, me pushim me pagesë dhe pa pagesë.',
          'Kërkesat kalojnë te aprovuesi; punonjësi sheh vetëm kërkesat e veta.',
          'Kalendari i pushimeve dhe raporti i bilancit të ditëve për çdo punëtor.',
        ],
      },
      {
        id: 'dokumentet',
        time: '13:15',
        caption: 'HR-ja ruan kontratën e re.',
        title: 'Organizo dokumentet',
        lead: 'Dosja e çdo punëtori, me dokumentet sipas kategorive dhe shabllone për kontrata e vendime.',
        points: [
          'Llojet e dokumenteve sipas kategorive — identifikim, kontratë, kualifikim, shëndetësi, financiare.',
          'Formatet e pranuara dhe dokumentet e detyrueshme përcaktohen nga kompania.',
          'Shabllone për kontrata, vendime dhe vërejtje.',
        ],
      },
      {
        id: 'pagat',
        time: '30.10',
        caption: 'Dalin fletëpagesat e tetorit.',
        title: 'Shiko fletëpagesat',
        lead: 'Paga llogaritet nga prezenca dhe orari, sipas rregullave fiskale të Kosovës. Çdo punëtor e sheh fletëpagesën e vet në PDF.',
        points: [
          'Shkallët e tatimit në të ardhura dhe kontributet pensionale llogariten mbi pagën bruto.',
          'Orët shtesë, puna e natës dhe festat merren nga prezenca dhe orari.',
          'Fletëpagesa në PDF për çdo punëtor, e dukshme në profilin e tij.',
          'Lista e pagave dhe urdhëresa e pagesës eksportohen në Excel ose PDF.',
        ],
      },
    ],
  },
  finalTitle: 'Shikojeni Nexuma-n në punë.',
  finalDesc: 'Provojeni falas për 5 ditë, ose na tregoni për ekipin tuaj dhe ju kontaktojmë për një demonstrim.',
  footer: { privacy: 'Privatësia', terms: 'Kushtet e përdorimit' },
  pricing: { minus: 'Një punonjës më pak', plus: 'Një punonjës më shumë', billing: 'Mënyra e faturimit', slip: 'Abonimi', slipMonth: 'për muaj', lineBase: 'Baza, deri 10 punonjës', lineExtra: (n) => `${n} punonjës shtesë × €3`, lineYearly: 'Zbritje vjetore −20%', total: 'Gjithsej në muaj', bigNote: 'Mbi 50 punonjës oferta personalizohet.' },
  scene: {
    label: 'Demonstrim me të dhëna shembull: Drita skanon me telefon QR-në e kioskës, hyrja regjistrohet në 08:00 dhe paneli Hyrje / Dalje e kalon në «Prezent»; pastaj kërkesa e saj për pushim vjetor aprovohet nga menaxheri.',
    play: 'Luaj animacionin',
    pause: 'Ndalo animacionin',
  },
  demoDialog: {
    title: 'Kërko demonstrim',
    desc: 'Na lini të dhënat dhe ju kontaktojmë me email.',
    name: 'Emri dhe mbiemri',
    company: 'Firma',
    email: 'Email',
    message: 'Mesazhi (opsional)',
    messagePh: 'p.sh. sa punëtorë keni dhe çka ju intereson më shumë',
    send: 'Dërgo kërkesën',
    sending: 'Duke dërguar…',
    close: 'Mbyll',
    doneTitle: 'E morëm kërkesën.',
    doneDesc: (email) => `Përgjigja ju vjen me email te ${email}.`,
    errFields: 'Shkruani emrin e firmës dhe një email të vlefshëm.',
    errRate: 'Keni dërguar disa kërkesa së fundi. Prisni pak, ose shkruani direkt te support@nexuma.app.',
    errSend: 'Kërkesa nuk u dërgua. Provoni pas pak, ose shkruani direkt te support@nexuma.app.',
    errNetwork: 'Nuk u lidhëm dot me serverin. Provoni pas pak, ose shkruani te support@nexuma.app.',
  },
  // Shkrimet brenda skenës 3D dhe pamjes statike — të dhëna shembull. Etiketat
  // janë ato të aplikacionit (sidebar, LivePresence, WorkerScanScreen, inbox).
  canvas: {
    sampleData: 'Të dhëna shembull',
    scanPresence: 'Skano Prezencën',
    tabScan: 'Skano kioskun',
    tabDirect: 'Aksion direkt',
    whatToDo: 'Çfarë dëshiron të bësh?',
    aimCamera: 'Drejtoje kamerën te QR-ja e kiosku…',
    noCamera: 'Demonstrim — pa kamerë',
    validQr: 'Kodi i QR-së është i vlefshëm',
    atKiosk: 'Kiosku: Hyrja kryesore',
    kioskTitle: 'Regjistro Prezencën',
    kioskHint: 'Hap app-in HR → «Skano QR» → skanoje këtë kod',
    kioskName: 'Hyrja kryesore',
    actions: ['Fillimi punës', 'Pauza', 'Kthim pauza', 'Dalja'],
    recorded: 'U regjistrua',
    recordedBody: 'Prezenca u ruajt me sukses.',
    checkIn: 'Hyrja',
    myLeaves: 'Pushimet e mia',
    annualLeave: 'Pushim vjetor',
    leaveDates: '02.11 – 04.11 · 3 ditë',
    forApproval: 'Për aprovim',
    approved: 'Aprovuar',
    nav: ['Punëtorët', 'Hyrje / Dalje', 'Kërkesat dhe Aprovimet', 'Pushimet', 'Pagat'],
    live: 'Monitorim Live',
    liveDate: 'E enjte, 29 tetor 2026',
    groups: ['Në punë', 'Në pauzë', 'Jashtë'],
    cols: ['Punëtori', 'Departamenti', 'Statusi', 'Hyrja'],
    depts: ['Magazina', 'Shitje', 'Recepsioni', 'Financa'],
    present: 'Prezent',
    absent: 'Mungon',
    onLeave: 'Me leje',
    request: 'Kërkesë pushimi',
    reject: 'Refuzo',
    approve: 'Aprovo',
    approvedBy: 'Aprovuar nga menaxheri',
    toastCheckIn: 'Hyrja u regjistrua · 08:00',
    toastLeave: 'Kërkesa për pushim u aprovua',
  },
};

const en = {
  title: 'Nexuma — Staff, schedules and payroll in one place',
  skip: 'Skip to content',
  logoLabel: 'Nexuma — top of page',
  navLabel: 'Main',
  navLabelMobile: 'Main (phone)',
  legalLabel: 'Legal',
  langLabel: 'Language',
  nav: { 'si-funksionon': 'How it works', prezenca: 'Attendance', pushimet: 'Leave', pagat: 'Payroll', cmimet: 'Pricing' },
  login: 'Sign in',
  demo: 'Request a demo',
  start: 'Start free',
  menuOpen: 'Open menu',
  menuClose: 'Close menu',
  hero: {
    h1a: 'Staff, schedules and payroll.',
    h1b: 'In one place.',
    h1Fit: 0.75,
    lead: 'Manage your team’s attendance, leave and documents from a single platform.',
    how: 'See how it works',
    note: 'The animation is a demo with sample data.',
  },
  day: {
    title: 'A working day, from the scan to the payslip.',
    clockLabel: 'Time of this moment',
    screens: {
      sample: 'Sample data',
      labels: {
        prezenca: 'App view: the Nexuma kiosk at the entrance shows a QR code that changes every 10 seconds, and Drita\'s phone confirms the check-in was recorded. Sample data.',
        pushimet: 'App view: Elira\'s annual leave request, 3 days, awaiting approval, with Reject and Approve buttons. Sample data.',
        dokumentet: 'App view: the contract list with each employee\'s status and signed document. Sample data.',
        pagat: 'App view: Drita\'s October payslip, from gross to net pay, sent by email. Sample data.',
      },
      roles: ['Warehouse', 'Sales', 'Reception', 'Finance'],
      colStatus: 'Status',
      kioskTitle: 'Register Attendance',
      kioskHint: 'Open the HR app → “Scan QR” → scan this code',
      kioskName: 'Main entrance',
      kioskDate: 'Thursday, 29 October',
      recorded: 'Recorded',
      recordedBody: 'Your attendance was saved.',
      startWork: 'Start work',
      requests: 'Requests & Approvals',
      annualLeave: 'Annual leave',
      forApproval: 'For approval',
      employee: 'Employee',
      period: 'Period',
      days: 'Days',
      daysLeft: (n) => `${n} days left`,
      reject: 'Reject',
      approve: 'Approve',
      contracts: 'Contracts',
      contractType: 'Type',
      contractTypes: ['Permanent contract', 'Fixed-term contract', 'Probation contract'],
      active: 'Active',
      expires: (n) => `Expires · ${n}d`,
      signed: 'Signed doc.',
      uploaded: 'Uploaded',
      payroll: 'Payroll',
      payslipTitle: 'Payslip',
      payslipPeriod: '1 – 31 October 2026',
      grossBase: 'Gross base pay',
      pension: 'Pension (employee)',
      tax: 'Income tax',
      net: 'Net pay',
      mailed: 'Payslip — October 2026.pdf',
      sent: 'Sent',
    },
    stages: [
      {
        id: 'prezenca',
        time: '07:58',
        caption: 'Drita scans the kiosk at the entrance.',
        title: 'Track attendance',
        lead: 'Employees scan the kiosk QR code at the entrance with their phone and check-in is recorded at the exact time. The kiosk is simply a Nexuma page on a tablet or computer; without it, check-in is done directly from the phone or the web.',
        points: [
          'Three ways to record time — kiosk QR, web clock and mobile app — chosen for the company or per employee.',
          'The kiosk QR code changes every 10 seconds, so a photo of it is useless later.',
          'A live attendance view for managers: present, absent, on leave.',
          'Attendance corrections are requested, approved and carried into payroll.',
        ],
      },
      {
        id: 'pushimet',
        time: '10:30',
        caption: 'Elira asks for three days off.',
        title: 'Manage leave',
        lead: 'The request goes to the approver, and each leave type’s day balance is tracked.',
        points: [
          'A catalogue of leave types, with paid and unpaid leave.',
          'Requests go to the approver; employees see only their own requests.',
          'A leave calendar and a day-balance report for every employee.',
        ],
      },
      {
        id: 'dokumentet',
        time: '13:15',
        caption: 'HR files the new contract.',
        title: 'Organise documents',
        lead: 'Every employee’s file, with documents by category and templates for contracts and decisions.',
        points: [
          'Document types by category — identification, contract, qualification, health, financial.',
          'The company sets the accepted formats and the required documents.',
          'Templates for contracts, decisions and warnings.',
        ],
      },
      {
        id: 'pagat',
        time: '30.10',
        caption: 'October’s payslips are out.',
        title: 'View payslips',
        lead: 'Pay is calculated from attendance and schedule under Kosovo’s tax rules. Every employee sees their own payslip as a PDF.',
        points: [
          'Income tax brackets and pension contributions are calculated on gross pay.',
          'Overtime, night work and public holidays come from attendance and the schedule.',
          'A PDF payslip for every employee, visible in their profile.',
          'The payroll list and the payment order export to Excel or PDF.',
        ],
      },
    ],
  },
  finalTitle: 'See Nexuma at work.',
  finalDesc: 'Try it free for 5 days, or tell us about your team and we’ll contact you for a demo.',
  footer: { privacy: 'Privacy', terms: 'Terms of use' },
  pricing: { minus: 'One employee fewer', plus: 'One employee more', billing: 'Billing period', slip: 'Subscription', slipMonth: 'per month', lineBase: 'Base, up to 10 employees', lineExtra: (n) => `${n} extra ${n === 1 ? 'employee' : 'employees'} × €3`, lineYearly: 'Yearly discount −20%', total: 'Total per month', bigNote: 'Above 50 employees the offer is tailored.' },
  scene: {
    label: 'Demo with sample data: Drita scans the kiosk QR code with her phone, check-in is recorded at 08:00 and the Check-in / Check-out panel turns her to “Present”; then her annual leave request is approved by the manager.',
    play: 'Play animation',
    pause: 'Pause animation',
  },
  demoDialog: {
    title: 'Request a demo',
    desc: 'Leave your details and we’ll contact you by email.',
    name: 'Full name',
    company: 'Company',
    email: 'Email',
    message: 'Message (optional)',
    messagePh: 'e.g. how many employees you have and what interests you most',
    send: 'Send request',
    sending: 'Sending…',
    close: 'Close',
    doneTitle: 'We got your request.',
    doneDesc: (email) => `We’ll reply by email to ${email}.`,
    errFields: 'Enter your company name and a valid email.',
    errRate: 'You’ve sent several requests recently. Please wait a little, or write directly to support@nexuma.app.',
    errSend: 'Your request was not sent. Please try again shortly, or write directly to support@nexuma.app.',
    errNetwork: 'We couldn’t reach the server. Please try again shortly, or write to support@nexuma.app.',
  },
  canvas: {
    sampleData: 'Sample data',
    scanPresence: 'Scan Presence',
    tabScan: 'Scan kiosk',
    tabDirect: 'Direct action',
    whatToDo: 'What do you want to do?',
    aimCamera: 'Aim camera at the kiosk QR…',
    noCamera: 'Demo — no camera',
    validQr: 'The QR code is valid',
    atKiosk: 'Kiosk: Main entrance',
    kioskTitle: 'Register Attendance',
    kioskHint: 'Open the HR app → “Scan QR” → scan this code',
    kioskName: 'Main entrance',
    actions: ['Start work', 'Break', 'Return from break', 'Check-out'],
    recorded: 'Recorded',
    recordedBody: 'Your attendance was saved.',
    checkIn: 'Check-in',
    myLeaves: 'My leave',
    annualLeave: 'Annual leave',
    leaveDates: '02.11 – 04.11 · 3 days',
    forApproval: 'For approval',
    approved: 'Approved',
    nav: ['Employees', 'Check-in / Check-out', 'Requests & Approvals', 'Leave', 'Salaries'],
    live: 'Live monitoring',
    liveDate: 'Thursday, 29 October 2026',
    groups: ['Working', 'On break', 'Out'],
    cols: ['Employee', 'Department', 'Status', 'In'],
    depts: ['Warehouse', 'Sales', 'Reception', 'Finance'],
    present: 'Present',
    absent: 'Absent',
    onLeave: 'On leave',
    request: 'Leave request',
    reject: 'Reject',
    approve: 'Approve',
    approvedBy: 'Approved by the manager',
    toastCheckIn: 'Check-in recorded · 08:00',
    toastLeave: 'Leave request approved',
  },
};

const de = {
  title: 'Nexuma — Personal, Zeiten und Löhne an einem Ort',
  skip: 'Zum Inhalt springen',
  logoLabel: 'Nexuma — Seitenanfang',
  navLabel: 'Hauptmenü',
  navLabelMobile: 'Hauptmenü (Telefon)',
  legalLabel: 'Rechtliches',
  langLabel: 'Sprache',
  nav: { 'si-funksionon': 'So funktioniert’s', prezenca: 'Anwesenheit', pushimet: 'Urlaub', pagat: 'Löhne', cmimet: 'Preise' },
  login: 'Anmelden',
  demo: 'Demo anfragen',
  start: 'Kostenlos starten',
  menuOpen: 'Menü öffnen',
  menuClose: 'Menü schließen',
  hero: {
    h1a: 'Personal, Zeiten und Löhne.',
    h1b: 'An einem Ort.',
    h1Fit: 0.76,
    lead: 'Verwalten Sie Anwesenheit, Urlaub und Dokumente Ihres Teams auf einer einzigen Plattform.',
    how: 'So funktioniert’s',
    note: 'Die Animation ist eine Demo mit Beispieldaten.',
  },
  day: {
    title: 'Ein Arbeitstag, vom Scan bis zur Lohnabrechnung.',
    clockLabel: 'Uhrzeit dieses Moments',
    screens: {
      sample: 'Beispieldaten',
      labels: {
        prezenca: 'App-Ansicht: Der Nexuma-Kiosk am Eingang zeigt einen QR-Code, der alle 10 Sekunden wechselt, und Dritas Handy bestätigt die Erfassung. Beispieldaten.',
        pushimet: 'App-Ansicht: Eliras Antrag auf Jahresurlaub, 3 Tage, zur Genehmigung, mit den Schaltflächen Ablehnen und Genehmigen. Beispieldaten.',
        dokumentet: 'App-Ansicht: die Vertragsliste mit Status und unterschriebenem Dokument je Mitarbeiter. Beispieldaten.',
        pagat: 'App-Ansicht: Dritas Oktober-Abrechnung, vom Brutto- zum Nettolohn, per E-Mail versendet. Beispieldaten.',
      },
      roles: ['Lager', 'Verkauf', 'Empfang', 'Finanzen'],
      colStatus: 'Status',
      kioskTitle: 'Anwesenheit registrieren',
      kioskHint: 'HR-App öffnen → „QR scannen“ → diesen Code scannen',
      kioskName: 'Haupteingang',
      kioskDate: 'Donnerstag, 29. Oktober',
      recorded: 'Erfasst',
      recordedBody: 'Anwesenheit gespeichert.',
      startWork: 'Arbeitsbeginn',
      requests: 'Anträge & Genehmigungen',
      annualLeave: 'Jahresurlaub',
      forApproval: 'Zur Genehmigung',
      employee: 'Mitarbeiter',
      period: 'Zeitraum',
      days: 'Tage',
      daysLeft: (n) => `${n} Tage übrig`,
      reject: 'Ablehnen',
      approve: 'Genehmigen',
      contracts: 'Verträge',
      contractType: 'Art',
      contractTypes: ['Unbefristeter Vertrag', 'Befristeter Vertrag', 'Probevertrag'],
      active: 'Aktiv',
      expires: (n) => `Läuft ab · ${n} T.`,
      signed: 'Unterschr. Dok.',
      uploaded: 'Hochgeladen',
      payroll: 'Löhne',
      payslipTitle: 'Lohnabrechnung',
      payslipPeriod: '1. – 31. Oktober 2026',
      grossBase: 'Bruttogrundlohn',
      pension: 'Rente (Arbeitnehmer)',
      tax: 'Einkommensteuer',
      net: 'Nettolohn',
      mailed: 'Lohnabrechnung — Oktober 2026.pdf',
      sent: 'Gesendet',
    },
    stages: [
      {
        id: 'prezenca',
        time: '07:58',
        caption: 'Drita scannt den Kiosk am Eingang.',
        title: 'Anwesenheit erfassen',
        lead: 'Mitarbeitende scannen den QR-Code am Kiosk mit dem Handy, und der Arbeitsbeginn wird minutengenau erfasst. Der Kiosk ist einfach eine Nexuma-Seite auf einem Tablet oder Computer; ohne ihn stempelt man direkt per Handy oder im Web.',
        points: [
          'Drei Erfassungswege — Kiosk-QR, Web-Stempeluhr und mobile App — wählbar für das Unternehmen oder je Mitarbeitenden.',
          'Der Kiosk-QR-Code ändert sich alle 10 Sekunden, ein Foto davon ist später wertlos.',
          'Live-Anwesenheitsansicht für Vorgesetzte: anwesend, abwesend, im Urlaub.',
          'Korrekturen der Anwesenheit werden beantragt, genehmigt und in die Lohnabrechnung übernommen.',
        ],
      },
      {
        id: 'pushimet',
        time: '10:30',
        caption: 'Elira beantragt drei Tage Urlaub.',
        title: 'Urlaub verwalten',
        lead: 'Der Antrag geht an die genehmigende Person, und das Tageskonto wird je Urlaubsart geführt.',
        points: [
          'Ein Katalog der Urlaubsarten, mit bezahltem und unbezahltem Urlaub.',
          'Anträge gehen an die genehmigende Person; Mitarbeitende sehen nur ihre eigenen Anträge.',
          'Urlaubskalender und Bericht zum Tagessaldo für alle Mitarbeitenden.',
        ],
      },
      {
        id: 'dokumentet',
        time: '13:15',
        caption: 'Die Personalabteilung legt den neuen Vertrag ab.',
        title: 'Dokumente ordnen',
        lead: 'Die Personalakte aller Mitarbeitenden, mit Dokumenten nach Kategorien und Vorlagen für Verträge und Beschlüsse.',
        points: [
          'Dokumentarten nach Kategorien — Ausweis, Vertrag, Qualifikation, Gesundheit, Finanzen.',
          'Zulässige Formate und Pflichtdokumente legt das Unternehmen fest.',
          'Vorlagen für Verträge, Beschlüsse und Abmahnungen.',
        ],
      },
      {
        id: 'pagat',
        time: '30.10',
        caption: 'Die Oktober-Abrechnungen sind da.',
        title: 'Lohnabrechnungen ansehen',
        lead: 'Der Lohn wird aus Anwesenheit und Dienstplan nach den Steuerregeln des Kosovo berechnet. Alle sehen ihre eigene Abrechnung als PDF.',
        points: [
          'Einkommensteuerstufen und Rentenbeiträge werden auf den Bruttolohn berechnet.',
          'Überstunden, Nachtarbeit und Feiertage kommen aus Anwesenheit und Dienstplan.',
          'Eine PDF-Lohnabrechnung für alle Mitarbeitenden, sichtbar im eigenen Profil.',
          'Lohnliste und Zahlungsauftrag lassen sich nach Excel oder PDF exportieren.',
        ],
      },
    ],
  },
  finalTitle: 'Erleben Sie Nexuma im Einsatz.',
  finalDesc: 'Testen Sie 5 Tage kostenlos, oder erzählen Sie uns von Ihrem Team und wir melden uns für eine Demo.',
  footer: { privacy: 'Datenschutz', terms: 'Nutzungsbedingungen' },
  pricing: { minus: 'Ein Mitarbeitender weniger', plus: 'Ein Mitarbeitender mehr', billing: 'Abrechnungszeitraum', slip: 'Abonnement', slipMonth: 'pro Monat', lineBase: 'Basis, bis 10 Mitarbeitende', lineExtra: (n) => (n === 1 ? '1 weiterer Mitarbeitender × €3' : `${n} weitere Mitarbeitende × €3`), lineYearly: 'Jahresrabatt −20%', total: 'Gesamt pro Monat', bigNote: 'Ab 50 Mitarbeitenden wird das Angebot individuell erstellt.' },
  scene: {
    label: 'Demo mit Beispieldaten: Drita scannt den QR-Code am Kiosk mit dem Handy, der Arbeitsbeginn wird um 08:00 erfasst und das Panel Ein-/Ausstempeln zeigt sie als „Anwesend“; danach genehmigt der Manager ihren Antrag auf Jahresurlaub.',
    play: 'Animation abspielen',
    pause: 'Animation anhalten',
  },
  demoDialog: {
    title: 'Demo anfragen',
    desc: 'Hinterlassen Sie Ihre Daten, und wir melden uns per E-Mail.',
    name: 'Vor- und Nachname',
    company: 'Firma',
    email: 'E-Mail',
    message: 'Nachricht (optional)',
    messagePh: 'z. B. wie viele Mitarbeitende Sie haben und was Sie am meisten interessiert',
    send: 'Anfrage senden',
    sending: 'Wird gesendet…',
    close: 'Schließen',
    doneTitle: 'Ihre Anfrage ist angekommen.',
    doneDesc: (email) => `Wir antworten per E-Mail an ${email}.`,
    errFields: 'Geben Sie den Firmennamen und eine gültige E-Mail-Adresse ein.',
    errRate: 'Sie haben kürzlich mehrere Anfragen gesendet. Bitte warten Sie kurz oder schreiben Sie direkt an support@nexuma.app.',
    errSend: 'Ihre Anfrage wurde nicht gesendet. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie direkt an support@nexuma.app.',
    errNetwork: 'Der Server ist nicht erreichbar. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie an support@nexuma.app.',
  },
  canvas: {
    sampleData: 'Beispieldaten',
    scanPresence: 'Anwesenheit scannen',
    tabScan: 'Kiosk scannen',
    tabDirect: 'Direktaktion',
    whatToDo: 'Was möchten Sie tun?',
    aimCamera: 'Kamera auf den Kiosk-QR richten…',
    noCamera: 'Demo — ohne Kamera',
    validQr: 'Der QR-Code ist gültig',
    atKiosk: 'Kiosk: Haupteingang',
    kioskTitle: 'Anwesenheit registrieren',
    kioskHint: 'HR-App öffnen → „QR scannen“ → diesen Code scannen',
    kioskName: 'Haupteingang',
    actions: ['Arbeitsbeginn', 'Pause', 'Rückkehr von der Pause', 'Auschecken'],
    recorded: 'Erfasst',
    recordedBody: 'Anwesenheit gespeichert.',
    checkIn: 'Kommen',
    myLeaves: 'Mein Urlaub',
    annualLeave: 'Jahresurlaub',
    leaveDates: '02.11. – 04.11. · 3 Tage',
    forApproval: 'Zur Genehmigung',
    approved: 'Genehmigt',
    nav: ['Mitarbeiter', 'Ein-/Ausstempeln', 'Anträge & Genehmigungen', 'Urlaub', 'Gehälter'],
    live: 'Live-Monitoring',
    liveDate: 'Donnerstag, 29. Oktober 2026',
    groups: ['Bei der Arbeit', 'In Pause', 'Abwesend'],
    cols: ['Mitarbeiter', 'Abteilung', 'Status', 'Kommen'],
    depts: ['Lager', 'Verkauf', 'Empfang', 'Finanzen'],
    present: 'Anwesend',
    absent: 'Abwesend',
    onLeave: 'Im Urlaub',
    request: 'Urlaubsantrag',
    reject: 'Ablehnen',
    approve: 'Genehmigen',
    approvedBy: 'Vom Manager genehmigt',
    toastCheckIn: 'Kommen erfasst · 08:00',
    toastLeave: 'Urlaubsantrag genehmigt',
  },
};

export const PRESENTATION_CONTENT = { sq, en, de };

/** `en-US` → `en`; gjuhë e panjohur → shqip, si te landing-u. */
export const pageLang = (lang) => {
  const code = String(lang || '').slice(0, 2);
  return PRESENTATION_CONTENT[code] ? code : 'sq';
};

export function getPresentationContent(lang) {
  return PRESENTATION_CONTENT[pageLang(lang)];
}
